import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../services/apiServices";
 

// Fetch all tickets
export const fetchTickets = createAsyncThunk("tickets/fetchAll", async () => {
  const response = await apiService.get("/tickets");
  return response.data;
});

// Fetch ticket by ID
export const fetchTicketById = createAsyncThunk("tickets/fetchById", async (id) => {
  const response = await apiService.get(`/tickets/${id}`);
  return response.data;
});

// Create or Update Ticket
export const saveTicket = createAsyncThunk("tickets/save", async (ticketData) => {
  if (ticketData._id) {
    const response = await apiService.put(`/tickets/${ticketData._id}`, ticketData);
    return response.data;
  } else {
    const response = await apiService.post("/tickets", ticketData);
    return response.data;
  }
});
export const updateTicketStatus = createAsyncThunk("tickets/updateTicketStatus", async (ticketData) => {
  if (ticketData._id) {
    const response = await apiService.put(`/tickets/${ticketData._id}/ticket-status/${ticketData.ticketStatus}`);
    return response.data;
  }  
});
export const updateTicketRepairStatus = createAsyncThunk("tickets/updateTicketRepairStatus", async (ticketData) => {
  if (ticketData._id) {
    const response = await apiService.put(`/tickets/${ticketData._id}/repair-status/${ticketData.repairStatus}`);
    return response.data;
  }  
});

export const deleteTicket = createAsyncThunk('Tickets/deleteTicket', async (id) => {
  await apiService.delete(`tickets/${id}`);
  return id;
});


const ticketSlice = createSlice({
  name: "tickets",
  initialState: { tickets: [], ticket: null, status: "idle" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.tickets = action.payload;
      })
      .addCase(fetchTicketById.fulfilled, (state, action) => {
        state.ticket = action.payload;
      })
      .addCase(saveTicket.fulfilled, (state, action) => {
        state.tickets.push(action.payload);
      });
  },
});

export default ticketSlice.reducer;
